module.exports = __webpack_public_path__ + "img/Slides.091089b3.png";